import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Modal } from '../../components/ui/Modal';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Plus, FileText, TrendingUp } from 'lucide-react';
import { procurementPlans } from '../../data/mockData';
export function ProcurementPlan() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const totalTarget = procurementPlans.reduce((sum, p) => sum + p.target, 0);
  const activeCount = procurementPlans.filter(p => p.status === 'Active').length;
  return <div className="space-y-6" data-id="element-476">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-477">
        <div data-id="element-478">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-479">
            Rencana Pengadaan
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-480">
            Manajemen kontrak dan rencana serapan gabah/beras
          </p>
        </div>
        <Button icon={<Plus size={18} data-id="element-482" />} onClick={() => setShowCreateModal(true)} data-id="element-481">
          Buat Rencana Baru
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6" data-id="element-483">
        <Card className="border-l-4 border-l-bulog-blue" data-id="element-484">
          <div className="flex items-center gap-4" data-id="element-485">
            <div className="p-3 bg-blue-100 text-bulog-blue rounded-lg flex-shrink-0" data-id="element-486">
              <FileText size={24} data-id="element-487" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-488">
              <p className="text-sm text-gray-500 mb-1" data-id="element-489">Total Target</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-490">
                {(totalTarget / 1000).toFixed(0)}k
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-491">Ton</p>
            </div>
          </div>
        </Card>
        <Card className="border-l-4 border-l-green-500" data-id="element-492">
          <div className="flex items-center gap-4" data-id="element-493">
            <div className="p-3 bg-green-100 text-green-600 rounded-lg flex-shrink-0" data-id="element-494">
              <TrendingUp size={24} data-id="element-495" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-496">
              <p className="text-sm text-gray-500 mb-1" data-id="element-497">Rencana Aktif</p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-498">{activeCount}</p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-499">Program</p>
            </div>
          </div>
        </Card>
      </div>

      <Card data-id="element-500">
        <Table columns={[{
        header: 'Nomor Rencana',
        accessor: (item: any) => <span className="font-mono text-sm font-semibold text-bulog-blue" data-id="element-502">
                  {item.id}
                </span>
      }, {
        header: 'Judul Pengadaan',
        accessor: (item: any) => <div className="min-w-0" data-id="element-503">
                  <div className="font-semibold text-gray-900 truncate" data-id="element-504">
                    {item.title}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5" data-id="element-505">
                    {item.period}
                  </div>
                </div>
      }, {
        header: 'Target (Ton)',
        accessor: (item: any) => <span className="font-semibold text-gray-900" data-id="element-506">
                  {item.target.toLocaleString()}
                </span>,
        className: 'hidden md:table-cell'
      }, {
        header: 'Budget',
        accessor: 'budget',
        className: 'hidden lg:table-cell'
      }, {
        header: 'Status',
        accessor: (item: any) => {
          const variants: any = {
            Active: 'success',
            Draft: 'neutral',
            Planning: 'info'
          };
          return <Badge variant={variants[item.status]} data-id="element-507">{item.status}</Badge>;
        }
      }]} data={procurementPlans} keyExtractor={i => i.id} data-id="element-501" />
      </Card>

      <Modal isOpen={showCreateModal} onClose={() => setShowCreateModal(false)} title="Buat Rencana Pengadaan Baru" size="lg" footer={<>
            <Button variant="outline" onClick={() => setShowCreateModal(false)} data-id="element-509">
              Batal
            </Button>
            <Button onClick={() => {
        setShowCreateModal(false);
        alert('Rencana pengadaan berhasil dibuat!');
      }} data-id="element-510">
              Simpan Rencana
            </Button>
          </>} data-id="element-508">
        <div className="space-y-4" data-id="element-511">
          <Input label="Judul Pengadaan" placeholder="Contoh: Pengadaan DN Masa Panen Raya" data-id="element-512" />
          <div className="grid grid-cols-2 gap-4" data-id="element-513">
            <Select label="Komoditas" options={[{
            value: '',
            label: 'Pilih komoditas...'
          }, {
            value: 'beras',
            label: 'Beras'
          }, {
            value: 'jagung',
            label: 'Jagung'
          }, {
            value: 'kedelai',
            label: 'Kedelai'
          }]} data-id="element-514" />
            <Input label="Target (Ton)" placeholder="500000" type="number" data-id="element-515" />
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-516">
            <Input type="date" label="Periode Mulai" data-id="element-517" />
            <Input type="date" label="Periode Selesai" data-id="element-518" />
          </div>
          <Input label="Estimasi Budget" placeholder="Rp 7.500.000.000.000" data-id="element-519" />
          <Select label="Sumber Pengadaan" options={[{
          value: '',
          label: 'Pilih sumber...'
        }, {
          value: 'dn',
          label: 'Dalam Negeri (Petani/Gapoktan)'
        }, {
          value: 'g2g',
          label: 'Import G2G'
        }, {
          value: 'tender',
          label: 'Tender Terbuka'
        }]} data-id="element-520" />
        </div>
      </Modal>
    </div>;
}